import * as queries from "./queries";
import * as mutations from "./mutations";

export const coordinator = { queries, mutations };
